import { library } from '@fortawesome/fontawesome-svg-core'
import { faVk, faFacebookF } from '@fortawesome/free-brands-svg-icons'
import {
  faFileAlt, faKey, faNewspaper, faCog, faSortUp, faSortDown, faBook, faPause, faPoll, faBan, faAlignLeft
} from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faVk, faFacebookF, faFileAlt, faKey, faNewspaper, faCog, faSortUp,
  faSortDown, faBook, faPause, faPoll, faCheckCircle, faBan, faAlignLeft)

export default FontAwesomeIcon
